// extracted by mini-css-extract-plugin
export default {"pdfStyle":"PDFViewer_pdfStyle__mU4vj"};